module.exports = __webpack_public_path__ + "img/login.e3347162.png";